import { lazyRouteComponent } from "@tanstack/react-router";




const Exam = lazyRouteComponent(() => import("./exam.view"), "Exam");

export const routeOptions = {
  component: Exam,
  head: () => ({
    meta: [
      { title: "Provsimulering inför kunskapsprovet – Alkoholprovet" },
      { name: "description", content: "Simulera kunskapsprovet för serveringstillstånd under riktiga villkor: tidsatt, kategorimix och 75% godkänd-gräns enligt FoHMFS 2014:7." },
      { property: "og:title", content: "Provsimulering inför kunskapsprovet – Alkoholprovet" },
      { property: "og:description", content: "Helprov eller modulprov per kategori — testa hur du klarar dig under tidspress innan du bokar det riktiga provet." },
      { property: "og:url", content: "https://alkoholprovet.se/exam" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/exam" }],
  }),
};
